/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Status of lumino
 */
export enum LuminoStatus {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  SOLD_OUT = 'sold-out',
}
